export const REDUX_SET_VALUE = "REDUX_SET_VALUE";
export const REDUX_SET_VALUE_RECURSIVE = "REDUX_SET_VALUE_RECURSIVE";

export function reduxSetValue(setting, value) {
    return {
        type: REDUX_SET_VALUE,
        payload: {
            setting: setting,
            value: value,
        },
    };
}

export function reduxSetValueRecursive(path, value) {
    return {
        type: REDUX_SET_VALUE_RECURSIVE,
        payload: {
            path: path,
            value: value,
        },
    };
}
